import { ref as databaseRef, get, query, orderByChild, equalTo } from "firebase/database";
//import { database } from './firebaseConfig'; // Ajustez le chemin selon votre configuration

import { database } from "../../FirebaseConfig";
//import { database, ref, set } from "../../FirebaseConfig";

// 1. Fonction pour obtenir tous les produits d'un utilisateur
export const getUserProducts = async (idUser) => {
  try {
    const productsRef = databaseRef(database, `products/${idUser}`);
    const snapshot = await get(productsRef);
    
    if (snapshot.exists()) {
      // Convertir l'objet en tableau
      const products = Object.values(snapshot.val());
      return products;
    }
    return [];
  } catch (error) {
    console.error("Erreur lors de la récupération des produits:", error);
    throw error;
  }
};

// 2. Fonction pour obtenir les produits d'un groupe spécifique
export const getProductsByGroup = async (idUser, idGroup) => {
  try {
    const productsRef = databaseRef(database, `products/${idUser}`);
    const snapshot = await get(productsRef);
    
    if (snapshot.exists()) {
      const allProducts = Object.values(snapshot.val());
      // Filtrer les produits par idGroup
      const groupProducts = allProducts.filter(product => product.idGroup === idGroup);
      return groupProducts;
    }
    return [];
  } catch (error) {
    console.error("Erreur lors de la récupération des produits du groupe:", error);
    throw error;
  }
};

// 3. Fonction pour rechercher un produit spécifique
export const getProductById = async (idUser, productId) => {
  try {
    const productRef = databaseRef(database, `products/${idUser}/${productId}`);
    const snapshot = await get(productRef);
    
    if (snapshot.exists()) {
      return snapshot.val();
    }
    return null;
  } catch (error) {
    console.error("Erreur lors de la récupération du produit:", error);
    throw error;
  }
};

// 4. Fonction pour rechercher des produits par titre (recherche)
export const searchProducts = async (idUser, searchTerm) => {
  try {
    const productsRef = databaseRef(database, `products/${idUser}`);
    const snapshot = await get(productsRef);
    
    if (snapshot.exists()) {
      const allProducts = Object.values(snapshot.val());
      // Filtrer les produits dont le titre contient le terme recherché
      const searchResults = allProducts.filter(product => 
        product.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
      return searchResults;
    }
    return [];
  } catch (error) {
    console.error("Erreur lors de la recherche des produits:", error);
    throw error;
  }
};